import React from "react";
import { packages } from "../mock";
import { formatPrice } from "../context/CartContext";
import { ArrowRight } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function PackageDeals() {
  const ref = useReveal();
  return (
    <section id="packages" className="bg-gray-50 py-16">
      <div ref={ref} className="reveal mx-auto max-w-7xl px-4 lg:px-8">
        <div className="mb-8 text-center">
          <h2 className="font-heading text-2xl font-extrabold text-navy md:text-3xl">Package Deals</h2>
          <p className="mt-2 text-sm text-navy/60">Complete, ready-to-train setups at bundle pricing.</p>
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          {packages.map((pkg) => (
            <a
              key={pkg.id}
              href="#"
              className="group relative flex min-h-[300px] items-end overflow-hidden rounded-3xl"
            >
              <img
                src={pkg.image}
                alt={pkg.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/90 via-navy-dark/40 to-transparent" />
              <div className="relative p-8">
                <h3 className="font-heading text-2xl font-extrabold text-white">{pkg.title}</h3>
                <p className="mt-1 text-sm text-white/80">{pkg.desc}</p>
                <p className="mt-3 text-white/70">
                  From <span className="font-heading text-xl font-bold text-brand">{formatPrice(pkg.price)}</span>
                </p>
                <span className="mt-4 inline-flex items-center gap-2 rounded-full bg-white px-6 py-2.5 text-xs font-bold uppercase tracking-wide text-navy transition-all group-hover:gap-3 group-hover:bg-brand group-hover:text-white">
                  Explore Package <ArrowRight size={14} />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
